<template>
    <div class="container-fluid d-flex align-items-center justify-content-center vh-100">
      <div class="w-100">
      <div class="row justify-content-center">
            <div class="col-3 my-3 text-center">
                <img width="300" src="../assets/health-here-logo.svg"/>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="alert alert-danger col-3" role="alert" v-show="errors.length > 0">
                <div v-for="(error, index) in errors" :key="index">{{ error }}</div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-3">
                <form class="form-horizontal">
                    <div class="form-group">
                        <label for="inputEmail3" class="control-label">Email</label>
                        <div class="">
                            <input type="email" v-model="email" class="form-control" id="inputEmail3" placeholder="Email">
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="resetTokenField" class="control-label">Reset Token</label>
                        <div class="">
                            <input type="text" :value="token" class="form-control" id="resetTokenField" placeholder="Reset Token">
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="inputPassword3" class="control-label">Password</label>
                        <div class="">
                            <input type="password" v-model="password" class="form-control" id="inputPassword3" placeholder="Password">
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="">
                            <button type="submit" @click.prevent="submit()" class="btn btn-orange btn-block">Change Password</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
  import api from '../services/api'

  export default {
    name: 'ResetPassword',

    props: {
      token: {
        type: String,
        required: false
      }
    },

    data () {
      return {
        resetToken: this.token,
        email: '',
        password: '',
        errors: []
      }
    },

    methods: {
      submit () {
        this.errors = []
        const credentials = {
          email: this.email,
          resetToken: this.resetToken,
          password: this.password
        }

        api.post('/Auth/ResetPassword', credentials).then(response => {

          this.$router.push({ path: 'login', query: { message: 'Password has been changed' } })
        }, errorResponse => {
          if (errorResponse.response.data) {
            if (errorResponse.response.data.password) {
              this.errors = errorResponse.response.data.password
            } else if (errorResponse.response.data.login_failure) {
              this.errors = errorResponse.response.data.login_failure
            } else {
              this.errors = [errorResponse.response.data]
            }
          } else {
            this.errors = [errorResponse.message]
          }
        })

      }
    }
  }
</script>

<style scoped>

</style>
